






























































































import {Terminal, TerminalConfigNext, TerminalGuiInfo} from "../../modules/models";
import Api from "./Api";
import {Component, Inject, Watch} from "vue-property-decorator";
import AddTerminalDialog from "./AddTerminalDialog.vue";
import rd from "../../modules/vRoutedefs";
import CompanyUserRequired from "../CompanyRequired";
import {WarningColor} from "@/modules/constants";

@Component({
    components: {
      "at-add-terminal": AddTerminalDialog,
    }
})
export default class TerminalOverview extends CompanyUserRequired {
    @Inject()
    api!: Api;

    termInfos: TerminalGuiInfo[] = [];
    pendingTerminals: TerminalConfigNext[] = [];
    showArchived = false;
    showAddTerminal = false;
    showTerminalAdded = false;
    addedTerminalDescr = "";

    readonly warningColor = WarningColor;

    get isSuper() {
        return this.user.isCompanySuper(this.company.orgNum);
    }

    @Watch("showArchived")
    async loadTerminals() {
        await this.baseApi.loadCompanyPromise();
        this.termInfos = await this.api.fetchTerminals(this.company.orgNum, this.showArchived);
    }

    locationPageTo(locid: number) {
        return {name: rd.locations.location.name, params: {locationId: locid}};
    }
    terminalPageTo(guid: string) {
        return {name: rd.terminals.terminal.name, params: {guid: guid}};
    }
    get orderPageTo() {
        return {name: rd.shop.name};
    }
    terminalTitleClasses(terminal: Terminal) {
        let classes = ["headline"];
        if(terminal.cleanupTs != null) {
            classes.push("deleted--text");
        }
        return classes;
    }
    pendingTerminalPageTo(guid: string) {
        return {name: rd.terminals.pending.name, params: {guid: guid}};
    }

    terminalAdded(description: string) {
        this.addedTerminalDescr = description;
        this.showTerminalAdded = true;
        this.loadPendingTerminals();
    }

    async loadPendingTerminals() {
        this.pendingTerminals = await this.api.fetchPendingTerminalSetups(this.company.orgNum);
    }

    imeiSearch: string | null = null;
    imeiSearching = false;
    async doImeiSearch() {
        if(this.imeiSearch) {
            if(this.imeiSearch.length > 15) {
                this.emitError(new Error("imei søk maks lengde er 15 siffer"));
            }
            if(this.imeiSearch.length > 0 && this.imeiSearch.length < 4) {
                this.emitError(new Error("imei søk må minimum ha 4 siffer"))
            }
        }
        this.imeiSearching = true;
        try {
            if (this.imeiSearch && this.imeiSearch.length > 3) {
                let srch = this.imeiSearch;
                if(srch.length == 15){
                    srch = srch.substr(0, 14);
                }
                this.termInfos = await this.api.imeiSearch(srch);
            } else {
                await this.loadTerminals();
            }
        } finally {
            this.imeiSearching = false;
        }
    }

    // Resets the view to default terminal list when search field is cleared
    @Watch("imeiSearch")
    async maybeReset() {
        if(this.imeiSearch == null || this.imeiSearch.length == 0) {
            await this.doImeiSearch();
        }
    }

    readonly docTo = rd.docs.terminal.path;

    // Hook
    created() {
        this.loadTerminals();
        this.loadPendingTerminals();
    }
}
